import React, { useEffect, useContext } from "react";

import "../assets/css/app.css";

import { Switch, Route, withRouter, Redirect } from "react-router-dom";

import AuthContext from "../components/auth/index";
import Login from "../components/auth/login";
import Logout from "../components/auth/logout";

import Termo from "../layout/Termo";
import LoginApp from "../layout/LoginApp";
import TabJogo from "../layout/TabJogo";
import TabEstudo from "../layout/TabEstudo";

import TabRanking from "../layout/TabRanking";
import Profile from "../layout/profile";
import Statistic from "../layout/statistic";
import TabRegras from "../layout/TabRegras";
import TabPerguntas from "../layout/TabPerguntas";
import TabFaq from "../layout/TabFaq";
import TabTermoSim from "../layout/TabTermoSim";
import TabSobre from "../layout/TabSobre";
import TabSelTipo from "../layout/TabSelTipo";
import TabSelTema from "../layout/TabSelTema";
import TabSingle from "../layout/TabSingle";
import TabPergunta from "../layout/TabPergunta";
import TabMulti from "../layout/TabMulti";
import TabMultiFim from "../layout/TabMultiFim";
import TabDesafio from "../layout/TabDesafio";
import { useWebsocket } from "../hooks/websocket";

const AnimatedSwitch = withRouter(({ location }) => (
  <Switch location={location}>
    <Route path="/" exact component={(props) => <LoginApp {...props} />} />
    <Route
      path="/login"
      component={(props) => <Login redirectTo="/termo" {...props} />}
    />
    <Route
      path="/logout"
      component={(props) => <Logout redirectTo="/" {...props} />}
    />
    <PrivateRoute path="/termo" component={(props) => <Termo {...props} />} />
    <PrivateRoute
      path="/tab/jogo"
      component={(props) => <TabJogo {...props} />}
    />
    <PrivateRoute
      path="/tab/estudo"
      component={(props) => <TabEstudo {...props} />}
    />
    <PrivateRoute
      path="/tab/ranking"
      component={(props) => <TabRanking {...props} />}
    />
    <PrivateRoute
      path="/tab/perfil"
      component={(props) => <Profile {...props} />}
    />
    <PrivateRoute
      path="/tab/statistic"
      component={(props) => <Statistic {...props} />}
    />{" "}
    <PrivateRoute
      path="/tab/regras"
      component={(props) => <TabRegras {...props} />}
    />
    <PrivateRoute
      path="/tab/perguntas"
      component={(props) => <TabPerguntas {...props} />}
    />
    <PrivateRoute
      path="/tab/faq"
      component={(props) => <TabFaq {...props} />}
    />
    <PrivateRoute
      path="/tab/termo/sim"
      component={(props) => <TabTermoSim {...props} />}
    />{" "}
    <PrivateRoute
      path="/tab/sobre"
      component={(props) => <TabSobre {...props} />}
    />
    <PrivateRoute
      path="/tab/type/:categoryId"
      component={(props) => <TabSelTipo {...props} />}
    />
    <PrivateRoute
      path="/tab/theme/:type/:categoryId"
      component={(props) => <TabSelTema {...props} />}
    />
    <PrivateRoute
      path="/tab/single/:categoryId/:themeId"
      component={(props) => <TabSingle {...props} />}
    />
    <PrivateRoute
      path="/tab/pergunta/:indexConteudo/:indexTema/:nDif/:indexPergunta"
      component={(props) => <TabPergunta {...props} />}
    />
    <PrivateRoute
      path="/tab/multi/:indexConteudo/:indexTema"
      component={(props) => <TabMulti {...props} />}
    />
    <PrivateRoute
      path="/tab/desafio/:currentQuestion"
      component={(props) => <TabDesafio {...props} />}
    />
    <Route
      path="/tab/multi-fim"
      component={(props) => <TabMultiFim {...props} />}
    />
  </Switch>
));

const PrivateRoute = ({ component: Component }) => {
  const { keycloak } = useContext(AuthContext);
  const { stompClient } = useWebsocket();
  return (
    <AuthContext.Provider>
      <Route
        render={(props) => {
          //Se tiver autenticado abre o componente, caso contrário abre a tela de login.
          return keycloak.authenticated ? (
            <Component {...props} stompClient={stompClient} />
          ) : (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          );
        }}
      />
    </AuthContext.Provider>
  );
};

export default function Routes(props) {
  useEffect(() => {}, []);

  return (
    <>
      <AnimatedSwitch />
    </>
  );
}
